<template>
    <transition name="fade">
        <div
            class="modal is-active"
            v-if="modalActive"
        >
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ modalContent.title }}</p>
                    <button
                        class="delete"
                        aria-label="close"
                        @click="cancelModal"
                    ></button>
                </header>
                <section class="modal-card-body">
                    <div
                        class="content"
                        v-html="modalContent.content"
                    ></div>
                    <div
                        class="select is-fullwidth"
                        v-if="modalContent.select"
                    >
                        <select v-model="selected">
                            <option value="">-- wybierz powód --</option>
                            <option
                                v-for="(selectItem, idx) in modalContent.select"
                                :value="idx"
                                v-bind:key="selectItem"
                            >{{ selectItem }}</option>
                        </select>
                    </div>
                    <div
                        class="is-fullwidth"
                        v-if="modalContent.textarea"
                    >
                        <textarea
                            class="textarea"
                            v-model="textarea"
                        ></textarea>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button
                        class="button is-success is-fullwidth"
                        :class="{ 'button--loading': modalIsPending }"
                        :disabled="this.modalAction.confirm.payloadFromSelect && selected == ''"
                        @click="confirm"
                        v-if="modalButton.confirm"
                    >
                        {{ modalButton.confirm }}
                        <span class="icon button__icon">
                            <svg-icon type="loader" />
                        </span>
                    </button>
                    <button
                        class="button is-danger is-fullwidth"
                        @click="discard"
                        v-if="modalButton.discard"
                    >
                        {{ modalButton.discard }}
                    </button>
                </footer>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import SvgIcon from '@/components/SvgIcon'

export default {
    components: {
        'svg-icon': SvgIcon
    },
    data() {
        return {
            selected: '',
            textarea: ''
        }
    },
    watch: {
        modalActive() {
            if(this.modalActive === true) {
                this.textarea = ''
            }
        }
    },
    computed: {
        ...mapGetters([
            'modalActive',
            'modalContent',
            'modalAction',
            'modalButton',
            'modalSelect',
            'modalIsPending'
        ])
    },
    methods: {
        cancelModal() {
            this.$store.dispatch('hideModal')
        },
        confirm(){
            // pending status for promises
            this.$store.dispatch('pendingModal', true)

            let name = this.modalAction.confirm.name
            let payload = this.modalAction.confirm.payload

            if(this.modalAction.confirm.payloadFromSelect == true){
                // not delivered
                payload.delivered = false
                payload.cancellationReason = this.selected
            }

            if(this.modalContent.textarea == true){
                payload.textarea = this.textarea
            }

            if(payload){
                this.$store.dispatch(name, payload)
            } else {
                this.$store.dispatch(name)
            }
        },
        discard(){
            let name = this.modalAction.discard.name
            let payload = this.modalAction.discard.payload

            if(payload && this.modalContent.textarea == true){
                payload.textarea = this.textarea
            }

            if(payload){
                this.$store.dispatch(name, payload)
            } else {
                this.$store.dispatch(name)
            }
        }
    }
}
</script>

<style lang="sass" scoped>
.modal-card
    width: calc( 100% - 3rem )
.select
    margin-bottom: 1rem
</style>
